module.exports = __webpack_public_path__ + "static/media/testimonials-2.b6d17018.jpg";